import uniq from 'lodash/uniq';
import { GeoItem, SuggestItem } from '@douleutarasgr/2gis-plugin';
import { Gis } from 'Douleutaras/components/Forms/gis.class';

type TwoGisItem = GeoItem | SuggestItem;

/**
 * Adapts a 2GIS geocoder/autocomplete result into a {@link Gis} instance so the rest
 * of the location flow (geo check, address display per country) stays provider-agnostic.
 *
 * The `Gis` constructor treats any object without a `geometry` field as its own
 * pre-built shape, so we hand it the fields it reads directly. `address` keeps the
 * raw 2GIS items array — `displayShortAddressPerCountry`/`displayFullAddressPerCountry`
 * read `address[0].full_name` for Cyprus.
 */
export const createGisFromTwoGis = (items: Array<TwoGisItem>): Gis | undefined => {
  const [first] = items;
  if (!first) {
    return undefined;
  }

  const description = first.address_name || first.full_name;

  const gisLike = {
    id: first.id,
    address: items,
    description,
    latitude: first.point && first.point.lat,
    longitude: first.point && first.point.lon,
    types: uniq(items.map(item => item.subtype || item.type)),
    title: description
  };

  return new Gis(gisLike as unknown as Gis);
};
